import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 26"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"none\" fill-rule=\"evenodd\"><rect width=\"39\" height=\"25\" x=\".5\" y=\".5\" fill=\"#F6F6F6\" stroke=\"#424446\" stroke-opacity=\".25\" rx=\"4\"></rect><path fill=\"#FF5A00\" d=\"M16.424 19.289h7V6.71h-7z\"></path><path fill=\"#EB001B\" d=\"M16.89 13a8.02 8.02 0 0 1 3.045-6.289A7.995 7.995 0 0 0 7 13a7.995 7.995 0 0 0 12.935 6.289A7.98 7.98 0 0 1 16.89 13\"></path><path fill=\"#F79E1B\" d=\"M32.87 13a7.995 7.995 0 0 1-12.935 6.289A7.96 7.96 0 0 0 22.979 13a8.02 8.02 0 0 0-3.044-6.289A7.94 7.94 0 0 1 24.867 5c4.424 0 8.002 3.601 8.002 8\"></path></g>", 1)
  ]))]))
}
export default { render: render }